import Button from '@atlaskit/button';
import Icon from '@atlaskit/icon';
import Tooltip from '@atlaskit/tooltip';
import React, { useContext } from 'react';
import { StarFillIcon, StarLineIcon } from '../../common/CustomIcons';
import { getLastOptionIdOrNull } from '../../util/ui-helper';
import { GlobalContext } from '../../common/GlobalContext';
import { CustomFieldType } from '../../../model/model';
import { FieldEditorActionReturnType } from '../../stateful/field-editor-stateful/FieldEditorStateful';
import { DefaultOptionHelper } from '../default-option/DefaultOptionHelper';
import { FieldEditorOptionAction } from './FieldEditor';
import { DTOCustomFieldOption, DTOGetDefaultOption } from '../../../generated-common';

export const FieldEditorSetDefaultOptionButton = ({
  parentOptionIds,
  option,
  isDisabled,
  defaultOption,
  fieldType,
  onUpdateOption,
}: {
  parentOptionIds: string[] | null;
  option: DTOCustomFieldOption;
  isDisabled: boolean;
  defaultOption: DTOGetDefaultOption;
  fieldType: CustomFieldType;
  onUpdateOption: (action: FieldEditorOptionAction) => Promise<FieldEditorActionReturnType>;
}) => {
  const { t } = useContext(GlobalContext);

  const isDefaultOption = DefaultOptionHelper.isCurrentlyDefaultOption(defaultOption, fieldType, option, getLastOptionIdOrNull(parentOptionIds));

  return (
    <div data-testid="ce-set-default-option-container">
      <Tooltip content={t(DefaultOptionHelper.getTranslationKeyForSetDefaultButtonTooltip(false, isDefaultOption, false))}>
        <span data-e2e-edit-inline-set-default={option.id} data-e2e-edit-inline-is-default={isDefaultOption}>
          <Button
            testId="ce-set-default-value-button"
            appearance="subtle"
            isDisabled={isDisabled}
            iconBefore={isDefaultOption === true ? <Icon label={`is default`} glyph={StarFillIcon} size="small" /> : <Icon label={`is not default`} glyph={StarLineIcon} size="small" />}
            onClick={() => {
              onUpdateOption(DefaultOptionHelper.calculateDTOSetDefaultOption(defaultOption, fieldType, option, parentOptionIds)).then((error: any) => {
                if (error && error['status'] !== 'SUCCESS') {
                  console.log('onUpdateOption - setDefault - ERROR', error);
                }
              });
            }}
          />
        </span>
      </Tooltip>
    </div>
  );
};
